import { AppLayout, BreadcrumbGroup } from '@amzn/awsui-components-react';
import { Switch, Route } from 'react-router-dom';
import React, { useState } from 'react';
import { AppContext, getInitialAppContext } from '../utils/appContext';
import { Sidebar } from '../utils/sidebar';
import { Navbar } from '../utils/Navbar';
import { IntegrationPage } from './IntegrationPage';
import { IntegrationDetails } from './IntegrationDetails';
import { QueryExplorerPage } from './QueryExplorerPage';
import { IndexExplorerPage } from './IndexExplorerPage';

const appContext = getInitialAppContext();

const Integration = () => {
  const setTimezone = (timezone: string) => {
    setState({ ...state, timezone: timezone });
  };
  const setBreadcrumbs = (breadcrumbs: any) => {
    setState({ ...state, breadcrumbs });
  };

  const [state, setState] = useState({
    ...getInitialAppContext(),
    setTimezone: setTimezone,
    setBreadcrumbs: setBreadcrumbs,
  });

  const [navigationOpen, setNavigationOpen] = useState(false);

  return (
    <div>
      <Navbar 
        title="Integration Tool"
        homeUrl="/integration"
        regionSwitcherActive={false}
        dropdownOptions={[]}
      />
      <div style={{ paddingTop: '60px' }}>
        <AppLayout
          disableContentPaddings={false}
          content={
            <AppContext.Provider value={state}>
              <Switch>
                <Route exact path="/integration" component={IntegrationPage} />
                <Route exact path="/integration/query-explorer" component={QueryExplorerPage} />
                <Route exact path="/integration/index-explorer" component={IndexExplorerPage} />
                <Route exact path="/integration/:clientId/:datasourceName" component={IntegrationDetails} />
              </Switch>
            </AppContext.Provider>
          }
          toolsHide={true}
          navigation={<Sidebar />}
          navigationOpen={navigationOpen}
          onNavigationChange={({detail}) => setNavigationOpen(detail.open)}
          headerSelector="#navbar"
          breadcrumbs={
            <BreadcrumbGroup
              items={appContext.breadcrumbs}
              ariaLabel="Breadcrumbs"
            />
          }
        />
      </div>
    </div>
  );
};

export { Integration };
